module.exports = __webpack_public_path__ + "img/b2.400ce280.png";